import axios from 'axios';
import { SettingsContext } from '@/utilities/settings-context';
import {i18n} from "@/utilities/vue-i18n";
import { HiddenAxios } from './axios-functions';
import { City, Country } from '@/types/tags';

export const getCountryList = async (hidden = false): Promise<Country[]> => {

  const lang = i18n.locale != undefined ? i18n.locale : 'sv';

  const countryList = (await (hidden ? HiddenAxios : axios).get(SettingsContext.getApiUrl('countryList'))).data as Record<string, Record<string, string>>;

  const countries = countryList[lang];

  return Object.keys(countries).reduce((array, key) => {

    array.push({id: key, label: countries[key]})

    return array;

  }, [] as Array<{id: string; label: string}>);
}

export const getCityList = async (hidden = false): Promise<City[]> => {

  const cities = (await (hidden ? HiddenAxios : axios).get<Record<string, string>>(SettingsContext.getApiUrl('cityList'))).data;

  return Object.keys(cities).reduce((array, key) => {

    array.push({id: cities[key], label: key});

    return array;

  }, [] as Array<{id: string; label: string}>);
}

export const getCity = (cities: City[], id: string): (City | null) => cities.find(value => value.id === id) ?? null;

export const getCountry = (countries: Country[], iso: string): (Country | null) => countries.find(value => value.id === iso) ?? null;
